import { createContext, useContext } from 'react';
const BottomSheetContext = createContext({ dispatch: () => { } });
BottomSheetContext.displayName = 'BottomSheetContext';
export const useBottomSheetContext = (component) => {
    const context = useContext(BottomSheetContext);
    if (context === null) {
        throw new Error(`<${component}> is missing a parent <BottomSheet /> component`);
    }
    return context;
};
export default BottomSheetContext;
